const rolesModel = vm => ({
  title: vm.$gettext('Roles'),
  endpoint: 'roles',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'guard_name',
      label: vm.$gettext('Guard Name'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Should normally be "api"')
    }
  ],
  filters: ['id', 'name', 'guard_name']
})

export default rolesModel
